import React from 'react';
import { PageLoader } from 'src/lib/PageLoader';

export const AsyncConsignmentPastThatDrivesUsPage = ({ ...props }): JSX.Element => (
  <PageLoader
    id='src/pages/ConsignmentThePastThatDrivesUsPage/ConsignmenPastThatDrivesUsPage'
    componentImport={async () => (await import('src/pages/ConsignmentPastThatDrivesUsPage/ConsignmentPastThatDrivesUsPage'))}
    head={() => async () => {
      return {
        title: 'The Past That Drives Us',
        description: 'Explore our heritage and the historic firearms collections that have shaped our auction house',
      };
    }}
    {...props}
  />
);
